/**
 * @name setAcdnToggle
 * @description アコーディオンの設定
 * @param {Object} accordion アコーディオンの要素
 * @param {Object} activeButton アコーディオンのボタン
 * @param {Object} activePanel アコーディオンのパネル
 * @param {Boolean} activePanelIsOpened アコーディオンのパネルの開閉の判断
 * @param {Function} toggleAccordion アコーディオンの開閉をする関数
 * @param {Object} e クリックした要素
 */
export function setAcdnToggle() {
    const accordionToggle = document.querySelectorAll(".acdn-toggle");
    if (accordionToggle.length === 0) return;

    accordionToggle.forEach((el) => el.addEventListener("click", (e) => toggleAccordion(e.currentTarget)));

    function toggleAccordion(panelToActivate) {
        const acdnButton = panelToActivate.querySelector(".acdn-btn");
        const acdnBox = panelToActivate.querySelector(".acdn-box");
        const acdnFlag = acdnButton.getAttribute("aria-expanded");

        if (acdnFlag === "true") {
            acdnButton.setAttribute("aria-expanded", false);
            acdnBox.setAttribute("aria-hidden", true);
        } else {
            acdnButton.setAttribute("aria-expanded", true);
            acdnBox.setAttribute("aria-hidden", false);
        }
    }
}